import React from 'react';
import { Navigate, useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import { Login } from "player-components";
import { useDispatch, useSelector } from "react-redux";
import { loginUserAsync, logout, selectErrorMessage, selectStatus } from "../../features/auth/authSlice";
import { selectSession } from "../../features/session/sessionSlice";
import { selectSetlistSessions } from "../../features/setlist/setlistSlice";
import {selectClientConfig} from "../../features/ui/uiSlice";

const LoginPage = () => {
    const location = useLocation();
    const dispatch = useDispatch();
    const loginStatus = useSelector(selectStatus);
    const loginErrorMessage = useSelector(selectErrorMessage);
    const session = useSelector(selectSession);
    const setlistSessions = useSelector(selectSetlistSessions);
    const clientConfiguration = useSelector(selectClientConfig);

    const [password, setPassword] = useState('Blesssing432%');
    const [username, setUsername] = useState('peter');

    // const [password, setPassword] = useState('');
    // const [username, setUsername] = useState('');

    const getRedirectionRoute = () => {
        // if (session?.id) return '/session'; // if user has a session loaded
        if (clientConfiguration.features.setlist.enabled && setlistSessions?.length > 0) return '/setlist'; // if user has any songs in their setlist
        return '/library'; // else go straight to library
    }

    useEffect(()=>{
        // setPassword('');
        // dispatch(logout());
    }, []);
    
    return loginStatus === 'fulfilled'  ? <Navigate to={getRedirectionRoute()}  state={{ from: location }} replace />:  <Login 
        onLogin={(a,b)=> {
            dispatch(loginUserAsync({username, password}));
        }}
        logoImageUrl={`${process.env.PUBLIC_URL}${clientConfiguration.images.loginLogo}`}
        splashImageUrl={`${process.env.PUBLIC_URL}${clientConfiguration.images.loginSplash}`}
        user={username}
        password={password}
        onPasswordChange={setPassword}
        onUserChange={setUsername}
        errorMessage={loginErrorMessage}
        loggingIn={loginStatus === 'pending'}
    />
}

export default LoginPage